import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { LeadCreatePayload } from '../types';
import { LEAD_LIST_KEY } from './constants';

const useLeadCreate = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: LeadCreatePayload }) => {
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/lead/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [LEAD_LIST_KEY] });
            setNotification({ message: `Form fill created` });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useLeadCreate;
